import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdEmail } from "react-icons/md";
import { Icon } from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { useAuth } from '../AuthContext';
import { userService } from '../services/api';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await userService.forgotPassword(formData.email)
        setError('');
        setSuccessMessage('email successfully set, please check your inbox for further instructions. It may be in your junk or spam');
        

    } catch (error) {
        console.error('Error:', error.response?.data || error.message);
        setSuccessMessage('');
        if (error.response && error.response.data && error.response.data.detail) {
            setError(error.response.data.detail); 
        } else {
            setError('Failed to process your request. Please try again later.');
        }
    }
  };

  return (
    <div className="flex flex-col justify-center items-center min-h-screen p-8 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/images/leelo_login.jpg')" }}>
      <div className="bg-gradient-to-br from-white/95 to-uranian-blue/80 backdrop-blur-sm shadow-xl rounded-lg w-full max-w-md p-16 my-auto border border-white/20">
        <h1 className="mt-0 text-tropical-indigo">Need to reset your password?</h1>
        <p className="text-gray-700">Please enter your email below.</p>
        {error && <p className="text-red-600 text-sm mt-2 p-2">{error}</p>}
        <form onSubmit={handleSubmit} className="flex flex-col">
          {/* Desktop version */}
          <div className="relative mb-4 hidden sm:block">
            <input 
              type="email" 
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email" 
              required 
              className="w-full p-3 border border-white/30 rounded text-sm mb-4 pr-10 bg-white/70 focus:bg-white/90 focus:border-tropical-indigo/50 transition-all"
            />
            <div className="absolute right-3 top-[40%] -translate-y-1/2 text-dark-gray pointer-events-none">
              <MdEmail size={20} />
            </div>
          </div>
          {/* Mobile version */}
          <div className="relative mb-4 sm:hidden">
            <input 
              type="email" 
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email" 
              className="w-full p-3 border border-white/30 rounded text-sm mb-4 pr-10 bg-white/70 focus:bg-white/90 focus:border-tropical-indigo/50 transition-all"
              required 
            />
            <div className="absolute right-3 top-[40%] -translate-y-1/2 text-dark-gray pointer-events-none">
              <MdEmail size={20} />
            </div>
          </div>
          <button type="submit" className="px-3 py-3 rounded font-bold text-base cursor-pointer transition-opacity bg-tropical-indigo text-white border border-tropical-indigo hover:opacity-90 w-full">Request to reset password</button>
        </form>
        <p className="mt-4 text-sm text-green-700">{successMessage}</p>
        <p className="mt-4 text-sm">Return to login page? <Link to="/login" className="text-tropical-indigo">Login</Link></p>
      </div>
      <footer className="text-white text-xs text-center fixed bottom-4 w-full z-10">
        2025 © Wenzi, Inc. <span className="mx-2">•</span> <Link to="/privacy" className="text-white no-underline hover:underline">Privacy Policy</Link>
        <span className="mx-2">•</span> <a href="https://discord.gg/z859AyVU3R" target="_blank" rel="noopener noreferrer" className="text-white no-underline hover:underline">Join our Discord</a>
      </footer>
    </div>
  );
};

export default ForgotPassword;
